
// Permissions needed to see records in dropdowns, possibly view.
const readPerms = [ 'show', 'list' ];

const appAdminRoles = {
	dashboard: true,
	analytics: true,
	sessions: true,
	interviews: readPerms,
	'form-entries': true,
	summaries: true
}

const adminRoles = {
	voiceovers: true,
	users: true,
	personas: readPerms,
	voices: readPerms
};

const superAdminRoles = {
	personas: true,
	voices: true,

	groups: true,
	methodologies: true,
	outcomes: true
}

const Roles = {
	superadmin: {
		name: 'Super Admin',
		permissions: {
			...appAdminRoles,
			...adminRoles,
			...superAdminRoles
		}
	},
	admin: {
		name: 'Admin',
		permissions: {
			...appAdminRoles,
			...adminRoles
		}
	},

	appadmin: {
		name: 'App Admin',
		permissions: {
			...appAdminRoles
		}
	},

	eventhost: {
		name: 'Event Manager',
		permissions: {
			sessions: readPerms
		}
	}
};

const makeRoleChoices = () => {
	const choices = [];
	for ( const id in Roles ) {
		const { name } = Roles[id];
		choices.push( { id, name } );
	}

	return choices;
}

const expandPermissions = ( perm ) => {
	const permissions = {};
	const allActions = [ 'list', 'create', 'edit', 'show', 'delete' ]; //update?

	for ( const resource in perm ) {
		const actions = perm[resource] === true ? allActions : perm[resource];
		if ( actions ) {
			permissions[resource] = actions;
		}
	}

	return permissions;
};

const RoleChoices = makeRoleChoices()

// @todo: Future optimization for multiple roles
const permissionsByRole = ( roles ) => {

	if ( ! Array.isArray( roles ) ) {
		roles = [ roles ];
	}

	const combinedRoles = {};

	for ( const role of roles ) {
		if ( role in Roles ) {
			Object.assign( combinedRoles, Roles[role].permissions );
		}
	}

	return expandPermissions( combinedRoles );
};

const roleCan = ( role, resource, action ) => {
	const perm = permissionsByRole( role );
	let success = false;

	if ( resource in perm ) {
		success = perm[resource].includes( action );
	}
	
	console.log( role, resource, action, success );

	return success;
};

module.exports = {
	permissionsByRole,
	RoleChoices,
	expandPermissions,
	makeRoleChoices,
	roleCan
};